module.exports = __webpack_public_path__ + "img/img-avatar10.bb5b440f.jpg";